export default __webpack_public_path__ + "static/media/Rune Stone of the Crimson Path.9a1bdb05.jpg";